import web from "../web";

class ApprenantsService {
    index(token){
        return web.get("/api/apprenants", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/apprenants", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/apprenants/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/apprenants/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/apprenants/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    getApprenantsByClasseoption(id,token){
        return web.get(`/api/apprenants/classeoption/${id}`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new ApprenantsService()